import { Link } from 'react-router-dom'

export default function GoBack() {
  return (
    <Link to="/">{"< Go Back"}</Link>
  )
}
